import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { useAppContext } from '../contexts/AppContext'
import LandingPage from '../pages'
import ManualPage from '../pages/manual'
import PostPurchaseModal from '../pages/PostPurchaseModal'

interface AppRouterProps {
  basePath?: string
}

const AppRouter = ({ basePath }: AppRouterProps) => {
  const { isPostPurchaseModal } = useAppContext()
  const normalizedBasePath = basePath?.replace(/\/$/, '') || ''
  const currentPath = window.location.pathname

  // Landing page design can be slightly changed when "post purchase modal" mode is on,
  // so we use a different component for that. But both are rendered at the root path.
  const RootPage = isPostPurchaseModal ? PostPurchaseModal : LandingPage

  // For root path, render directly without router to avoid history manipulation.
  // This is a workaround because RouterProvider triggers onPageFinished twice in Android's WebViewPreloadHelper.
  if (currentPath === normalizedBasePath + '/' || currentPath === normalizedBasePath) {
    return <RootPage />
  }

  // Use router only for non-root paths
  const routes = [
    { path: '/', element: <RootPage /> },
    { path: '/manual', element: <ManualPage /> },
  ]

  const router = createBrowserRouter(routes, { basename: normalizedBasePath })

  return <RouterProvider router={router} />
}

export default AppRouter
